<template>
  <div class="quill">
    <div :id="toolbarId">
      <div class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-strike"></button>
        <button class="ql-blockquote"></button>
        <button class="ql-link"></button>

        <button class="ql-header" value="1" style="margin-left:8px"></button>
        <button class="ql-header" value="2"></button>
        <button class="ql-script" value="sub"></button>
        <button class="ql-script" value="super"></button>
        <button class="ql-image"></button>
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
        <button class="ql-clean"></button>
      </div>
    </div>
    <div :id="editorId" :name="name" class="" ref="editor" style="position: relative; z-index: 10"></div>
  </div>
</template>
<style scoped>
.ql-formats {
  display: inline-block;
}
</style>
<script>
import Quill from "quill/core/quill";

export default {
  name: "html-editor",
  props: {
    value: {
      type: String,
      default: "",
    },
    name: String,
  },
  data() {
    return {
      editor: null,
      content: null,
      lastHtmlValue: "",
      editorId: null,
      toolbarId: null,
    };
  },
  methods: {
    initialize(Quill) {
      let quill;
      this.editor = quill = new Quill(`#${this.editorId}`, {
        theme: "snow",
        modules: {
          keyboard: {
            bindings: {
              paste: {
                key: 0x56,
                ctrlKey: true,
                handler: async (range, context) => {
                  let text = await navigator.clipboard.readText();
                  if(text && text.length) {
                    text = text.replace(/<([^>]+)>/gi, "");
                  }
                  if(text && text.length) {
                    quill.insertText(range.index, text);
                    quill.setSelection(range.index, text.length);
                  }
                }
              }
            }
          },
          toolbar: {
            container: `#${this.toolbarId}`,
            // handlers: {
            //   link: function link(value) {
            //     if (value) {
            //       var range = this.quill.getSelection();
            //       if (range == null || range.length == 0)
            //         return;
            //       var preview = this.quill.getText(range);
            //       if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
            //         preview = 'mailto:' + preview;
            //       }
            //       var tooltip = this.quill.theme.tooltip;
            //       tooltip.edit('link', preview);
            //     } else {
            //       this.quill.format('link', false);
            //     }
            //   }
            // }
          }
        },
      });

      this.editor.root.addEventListener("dblclick", () => {
        const selection = quill.getSelection();
        console.log(selection);
        const text = quill.getText(selection.index-1, selection.length+2);
        if(/^\[([A-Z_]*)]$/.test(text)) {
          quill.setSelection(selection.index-1, selection.length+2);
        }
      });

      // Patch la librairie Quill pour ajouter le https:// au début des url
      let saveFn = this.editor.theme.tooltip.save;
      this.editor.theme.tooltip.save = function () {
        if(this.root.getAttribute('data-mode') === 'link') {
          let value = this.textbox.value;
          if( ! /^\S+:/.test(value)) {
            this.textbox.value = 'https://' + value;
          }
        }
        saveFn.call(this);
      }

      // Patch la librairie Quill pour que le popup de lien ne dépasse pas le container parent (gauche-droite)
      this.editor.getBounds = function getBounds(index, length = 0) {
        let bounds;
        if (typeof index === 'number') {
          bounds = this.selection.getBounds(index, length);
        } else {
          bounds = this.selection.getBounds(index.index, index.length);
        }
        let containerBounds = this.container.getBoundingClientRect();

        let rsBounds = {
          bottom: bounds.bottom - containerBounds.top,
          height: bounds.height,
          left: bounds.left - containerBounds.left,
          right: bounds.right - containerBounds.left,
          top: bounds.top - containerBounds.top,
          width: bounds.width
        };

        let marge = 150;
        if(rsBounds.left <= marge) rsBounds.left = marge;
        if(rsBounds.left >= containerBounds.width-marge-25) rsBounds.left = containerBounds.width-marge-25;

        return rsBounds;
      }

      if (this.value && this.value.length > 0) {
        this.editor.pasteHTML(this.value);
      }

      let editorRef = this.$refs.editor;
      let node = editorRef.children[0];
      this.editor.on("text-change", () => {
        let html = node.innerHTML;
        if (html === "<p><br></p>") {
          html = "";
        }
        this.content = html;
        this.$emit("input", this.content);
      });
    },
    pasteHTML() {
      if (!this.editor) {
        return;
      }
      this.editor.pasteHTML(this.value);
    },
    randomString() {
      let text = "";
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
  },
  async mounted() {
    let Quill = await import("quill");
    Quill = Quill.default || Quill;
    this.editorId = this.randomString();
    this.toolbarId = this.randomString();
    this.$nextTick(() => {
      this.initialize(Quill);
    });
  },
  watch: {
    value(newVal) {
      if (newVal !== this.content) {
        this.pasteHTML(newVal);
      }
    },
  },
};
</script>
